import { Switch as MuiSwitch } from '@mui/material';
import { FormControlLabel } from './FormControlLabel';
import type { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

export type SwitchProps = MuiSwitchProps & { label?: string };

export const Switch = ({ label, ...rest }: SwitchProps): JSX.Element =>
  label ? (
    <FormControlLabel control={<MuiSwitch {...rest} />} label={label} />
  ) : (
    <MuiSwitch {...rest} />
  );
